import React, { useCallback, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const Container = styled.div`
    position: relative;
    width: 100%;
`

const Content = styled.div`
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
`

const DragHandle = styled.div`
    position: absolute;
    left: 50%;
    bottom: 4px;
    transform: translateX(-50%);
    /* bottom: 0; */
    /* left: 0;
  right: 0; */
    height: 6px;
    background: transparent;
    cursor: row-resize;
    background: var(--color-gray-300);
    width: 31px;
    height: 4px;
    border-radius: 100px;
    z-index: 99;
    /* &:hover {
    background: var(--color-gray-300);
  }
  
  &:active {
    background: rgba(0, 0, 0, 0.2);
  } */
`

interface ResizableBoxProps {
    children: React.ReactNode
    minHeight?: number
    maxHeight?: number
    defaultHeight?: number
    onHeightChange?: (height: number) => void
}

export const ResizableBox: React.FC<ResizableBoxProps> = ({
    children,
    minHeight = 100,
    maxHeight = 800,
    defaultHeight = 200,
    onHeightChange
}) => {
    const [height, setHeight] = useState(defaultHeight)
    const containerRef = useRef<HTMLDivElement>(null)
    const isDragging = useRef(false)
    const startY = useRef(0)
    const startHeight = useRef(0)

    const handleMouseDown = useCallback(
        (e: React.MouseEvent) => {
            isDragging.current = true
            startY.current = e.clientY
            startHeight.current = height
            document.body.style.cursor = 'row-resize'
            document.body.style.userSelect = 'none'
        },
        [height]
    )

    const handleMouseMove = useCallback(
        (e: MouseEvent) => {
            if (!isDragging.current) {
                return
            }

            const deltaY = e.clientY - startY.current
            const newHeight = Math.min(Math.max(startHeight.current + deltaY, minHeight), maxHeight)

            setHeight(newHeight)
            onHeightChange?.(newHeight)
        },
        [maxHeight, minHeight, onHeightChange]
    )

    const handleMouseUp = useCallback(() => {
        isDragging.current = false
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
    }, [])

    useEffect(() => {
        document.addEventListener('mousemove', handleMouseMove)
        document.addEventListener('mouseup', handleMouseUp)

        return () => {
            document.removeEventListener('mousemove', handleMouseMove)
            document.removeEventListener('mouseup', handleMouseUp)
        }
    }, [handleMouseMove, handleMouseUp])

    return (
        <Container ref={containerRef}>
            <Content style={{ height }}>{children}</Content>
            <DragHandle onMouseDown={handleMouseDown} />
        </Container>
    )
}
